import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DetailedTicket_ConversationEntry, DetailedTicket_ConversationEntry_Direction, DetailedTicket_ConversationEntry_MessageConversationEntry, PersistedTicketAttachment } from '@proto/hubspotr';

@Component({
  selector: 'app-conversation-entry-card',
  templateUrl: './conversation-entry-card.component.html',
  standalone: false
})
export class ConversationEntryCardComponent implements OnInit {

  @Input()
  public ticketId: string;
  @Input()
  public conversationEntry: DetailedTicket_ConversationEntry;

  @Output()
  public onAttachmentClicked = new EventEmitter<PersistedTicketAttachment>();

  public entryObject?: DetailedTicket_ConversationEntry_MessageConversationEntry;
  public attachments: PersistedTicketAttachment[] = [];

  ngOnInit(): void {
    const entry = this.conversationEntry.entry;
    const caseString = entry?.$case;

    // should also work for types other than "messageConversationEntry"
    this.entryObject = caseString ? entry[caseString] : undefined;
    this.attachments = this.entryObject?.attachments ?? [];
  }

  onAttachmentClick(attachment: PersistedTicketAttachment) {
    this.onAttachmentClicked.emit(attachment);
  }

  public get hasAttachment(): boolean {
    return this.attachments.length > 0;
  }

  public get incomingMessage(): boolean {
    return this.entryObject?.direction === DetailedTicket_ConversationEntry_Direction.DIRECTION_INCOMING;
  }

}
